import RichContent from "./RichContent";
import FaqAccordion from "./FaqAccordion";
import { ExternalLink } from "lucide-react";

// Renders the public Content SEO payload (content_seo) for product/category/
// brand pages: titled rich sections + FAQ accordion + external references.
// Empty sections never render. Static pages pass `flat` to blend inline.
export default function ContentSections({ content, flat = false }) {
  if (!content) return null;
  const { fields = [], faqs = [], external_refs = [] } = content;
  if (fields.length === 0 && faqs.length === 0 && external_refs.length === 0) return null;

  return (
    <div className={flat ? "space-y-8" : "mt-14 space-y-12"} data-testid="content-sections">
      {fields.map((f) => (
        <section key={f.key} data-testid={`content-section-${f.key}`}>
          <h2 className="font-playfair text-2xl sm:text-3xl text-white mb-4">{f.label}</h2>
          <RichContent html={f.html} />
        </section>
      ))}

      <FaqAccordion faqs={faqs} />

      {external_refs.length > 0 && (
        <section data-testid="external-refs">
          <h2 className="font-playfair text-xl text-white mb-4">References & Further Reading</h2>
          <ul className="space-y-2">
            {external_refs.map((r, i) => (
              <li key={i}>
                <a href={r.url} target={r.new_tab ? "_blank" : undefined} rel={r.rel}
                  className="inline-flex items-center gap-2 text-gold hover:underline text-sm" data-testid={`external-ref-${i}`}>
                  <ExternalLink className="h-3.5 w-3.5" /> {r.title}
                </a>
                {r.description && <span className="text-white/50 text-sm"> — {r.description}</span>}
              </li>
            ))}
          </ul>
        </section>
      )}
    </div>
  );
}
